import WhatsappTemplateFormScreen from "../../../../../screens/WhatsappTemplate/WhatsappTemplateForm/WhatsappTemplateFormScreen";

export const Whatsapp = () => {
  return <WhatsappTemplateFormScreen software="ChatBot" />;
};
